// extracted by mini-css-extract-plugin
export var banner = "_bh-0";
export var closeButton = "_bh-2";
export var greenCheckmark = "_bh-3";
export var hereLink = "_bh-4";
export var titleIcon = "_bh-1";